var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-control"},[(_vm.modal)?_c('div',{staticClass:"overlay"}):_vm._e(),_c('div',{staticClass:"loader",class:{
      fixed: !_vm.inline && !_vm.relativeToParent,
      relative: _vm.relativeToParent
    }},[_c('div',{staticClass:"spinner",style:(_vm.sizeProps)}),(_vm.text.length > 0)?_c('div',[_vm._v(_vm._s(_vm.text))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }